import React from "react";
import UserAnalytics from "../components/UserAnalytics/UserAnalytics";

export default function UserAnalyticsView() {
  return <UserAnalytics />;
}
